import {formatMoney, ucwords, escapeHtml} from '../../utils/utils';

const moment = require('moment');

// eslint-disable-next-line
$.fn.dataTable.ext.type.order['name-sorting-pre'] = function ( d ) {
  return d?ucwords(d):'яяяяя'
};

export default {
  methods: {
    setColumns(columns) {
      localStorage.setItem('contactsColumns_v1', JSON.stringify(columns))
    },
    getColumns() {
      let columns = [
        'sign-up',
        'custom',
        'monthly',
        'round-ups',
        'totals',
        'phone',
        'notifications',

        'age', 'gender',
        'employer', 'position',
        'address', 'city', 'state', 'zip-code'
      ];

      if (localStorage.getItem('contactsColumns_v1') !== null) {
        columns = JSON.parse(localStorage.getItem('contactsColumns_v1'));
      }

      let sortIndex = 0;
      const colTitles = ([].concat(...this.allColumns.map(group => group.columns))).reduce((res, val) => {

        res[val.key] = {
          title: val.title,
          'sort-param': val['sort-param'],
          'sort-index': (sortIndex++) + (val.hasOwnProperty('addSortIndex') ? Number(val.addSortIndex) : 0),
        };
        return res;
      }, {});

      const result = columns.map(col => {
        return {
          key: col,
          title: colTitles[col] ? colTitles[col].title : col,
          'sort-param': colTitles[col] ? colTitles[col]['sort-param'] : col,
          'sort-index': colTitles[col] ? colTitles[col]['sort-index'] : col,
        };
      });

      function compare(a, b) {
        if (a['sort-index'] < b['sort-index'])
          return -1;
        if (a['sort-index'] > b['sort-index'])
          return 1;
        return 0;
      }


      return result.sort(compare);
    },
    getDonorsCount(filter = 'all') {
      let resCount = 0;

      this.contacts.map(donor => {
        //donors, round-uds
        let show = true;

        if (filter === 'round-ups') {
          if (donor.status !== 'complete') {
            show = false;
          }
        }
        if (filter === 'donors') {
          if (donor.total <= 0) {
            show = false;
          }
        }

        if (this.searchDonorsName) {
          let re = new RegExp(this.searchDonorsName, 'ig');
          if (donor.name.search(re) === -1) {
            show = false;
          }
        }

        if (show) {
          resCount++;
        }

      });
      return resCount;
    },

    getStatusString: function(donor) {
      let className = '';
      if (donor.status === 'complete') {
        className = 'txt-green';
      }
      if (donor.status === 'incomplete') {
        className = 'txt-red';
      }

      return `<span class="${className} status round-up-status">${donor.status.replace('complete', 'active')}</span>`;
    },
    prepareParamValue: function(key, donor) {
      switch (key) {
        case 'sign-up':
          return `${moment(donor.created_at).format('MMM DD, YYYY')}
                <div class="info">Date Created</div>`;
        case 'round-ups':
          return `<span class="${donor.roundup_donation_total * 1 === 0
            ? 'txt-light-grey'
            : 'txt-blue'}">${donor.roundup_donation_total * 1 === 0 ? '--' : '$' +
            formatMoney(donor.roundup_donation_total / 100, 0, 3)}</span>
                <div class="info">Round-Ups</div>`;
        case 'custom':
          return `<span class="${donor.custom_donation_total * 1 === 0
            ? 'txt-light-grey'
            : 'txt-orange'}">${donor.custom_donation_total * 1 === 0 ? '--' : '$' +
            formatMoney(donor.custom_donation_total / 100, 0, 3)}</span>
                <div class="info">One-Time</div>`;
        case 'monthly':
          return `<span class="${donor.monthly_donations * 1 === 0
            ? 'txt-light-grey'
            : 'txt-green'}">${donor.monthly_donations * 1 === 0 ? '--' : '$' +
            formatMoney(donor.monthly_donations / 100, 0, 3)}</span>
                <div class="info">Monthly</div>`;
        case 'totals':
          return `<span class="${donor.total * 1 === 0 ? 'txt-light-grey' : ''}">${donor.total === null ? '--' : '$' +
            formatMoney(donor.total / 100, 0, 3)}</span>
                <div class="info">Total</div>`;
        case 'rup-status':
          return `${this.getStatusString(donor)}<div class="info">Round-Up Status</div>`;
        case 'phone':
          return (donor.phone_number ? donor.phone_number.replace(/(\d{3})(\d{3})(\d{4,10})/,
            '$1-$2-$3') : '--') + '<div class="info">Phone Number</div>';

        case 'notifications':
          return `<span class="txt-${donor.sms_enabled ? 'green' : 'red'} status">
${donor.sms_enabled ? 'ON' : 'OFF'}</span><div class="info">Texts</div>`;
      }
      return '';
    },
    /**
     * @param column
     * @param donor
     * @param type data|header|column
     * @param startIndex
     */
    getTableParam: function(column, donor, type = 'column', startIndex = 0) {
      switch (column) {
        case 'id_select':
          if (type === 'header') {
            return [''];
          }
          if (type === 'data') {
            return [donor.id];
          }
          return [

        //     <!--div class="checkbox-wrap">
        //   <label class="checkbox-container"><input class="check-donors"
        //   data-email="${row[startIndex + 1]}" data-uid="${row[startIndex + 2]}" type="checkbox"><span class="checkmark"></span></label>
        // </div-->
            {
              'checkboxes': {
                'selectRow': true,
                'selectAllRender': '<div class="check-cwrap"><label class="checkbox-container"><input class="check-donors dt-checkboxes" type="checkbox"><span class="checkmark"></span></label></div>'
              },
              'render': function(data, type){
                if(type === 'display'){
                  data = '<div class="check-cwrap"><label class="checkbox-container"><input class="check-donors dt-checkboxes" type="checkbox"><span class="checkmark"></span></label></div>';
                }

                return data;
              },
              'targets': startIndex,
            },
          ];
        case 'first_name':
          if (type === 'header') {
            return ['First Name'];
          }
          if (type === 'data') {
            return [escapeHtml(donor.fname)];
          }
          return [
            {
              'render': (data) => data,
              'targets': startIndex,
            },
          ];
        case 'last_name':
          if (type === 'header') {
            return ['Last Name'];
          }
          if (type === 'data') {
            return [escapeHtml(donor.lname)];
          }
          return [
            {
              'render': (data) => data,
              'targets': startIndex,
            },
          ];
        case 'email':
          if (type === 'header') {
            return ['Email'];
          }
          if (type === 'data') {
            return [escapeHtml(donor.email)];
          }
          return [
            {
              'render': (data) => data,
              'targets': startIndex,
            },
          ];
        case 'name':
          if (type === 'header') {
            return ['Name & Email', 'Email', 'id', 'short name', 'profile photo', 'sms_enabled', 'total', 'rups'];
          }
          if (type === 'data') {
            return [
              escapeHtml(donor.name),
              escapeHtml(donor.email),
              donor.id,
              escapeHtml(donor.short_name),
              donor.profile_photo,//4
              donor.sms_enabled,
              donor.total,
              donor.status];
          }

          return [
            {
              'render': (data, type, row) => {
                if (type === 'display') {

                  let avatar = row[startIndex + 3];
                  if (row[startIndex + 4]) {
                    avatar = `<img src="${row[startIndex + 4]}" alt="${data}" />`;
                  }

                  return `<div class="one-donor donor-${(row[startIndex + 5]
                    ? 'active'
                    : 'inactive')} donor-line-${row[startIndex  + 2]}" data-donor-id="${row[startIndex + 2]}">
                                    <div class="avatar show-donor-info mt-4" data-donor-id="${row[startIndex +
                  2]}">${avatar}</div>
                                    <div class="donor mt-3"><span class="show-donor-info" data-donor-id="${row[startIndex +
                  2]}">${data}</span><div class="info">${row[startIndex + 1]}</div></div>
                                </div>`;
                }

                return data;
              },
              'width': '290px',//290-32
              "type": "name-sorting",
              'targets': startIndex,
            },
            {'visible': false, 'targets': [startIndex + 1]},
            {'visible': false, 'targets': [startIndex + 2]},
            {'visible': false, 'targets': [startIndex + 3]},
            {'visible': false, 'targets': [startIndex + 4]},
            {'visible': false, 'targets': [startIndex + 5]},
            {'visible': false, 'targets': [startIndex + 6]},
            {'visible': false, 'targets': [startIndex + 7]},
          ];

        case 'sign-up':
          if (type === 'header') {
            return ['Date Created'];
          }
          if (type === 'data') {
            return [donor.created_at];
          }
          return [
            {
              'render': (data, type) => {
                if (type === 'display') {
                  return this.prepareParamValue('sign-up', {created_at: data});
                }

                return moment(data).valueOf();
              },
              'width': '165px',
              'targets': startIndex,
              'orderSequence': ['desc', 'asc'],
            },
          ];
        case 'round-ups':
          if (type === 'header') {
            return ['Round-Ups'];
          }
          if (type === 'data') {
            return [donor.roundup_donation_total];
          }

          return [
            {
              'render': (data, type) => {
                if (type === 'display') {
                  return this.prepareParamValue('round-ups', {roundup_donation_total: data});
                }
                return data;
              },
              'width': '100px',
              'orderSequence': ['desc', 'asc'],
              'targets': startIndex,
            },
          ];
        case 'custom':
          if (type === 'header') {
            return ['One Time'];
          }
          if (type === 'data') {
            return [donor.custom_donation_total];
          }

          return [
            {
              'render': (data, type) => {
                if (type === 'display') {
                  return this.prepareParamValue('custom', {custom_donation_total: data});
                }
                return data;
              },
              'width': '90px',
              'orderSequence': ['desc', 'asc'],
              'targets': startIndex,
            },
          ];
        case 'monthly':
          if (type === 'header') {
            return ['Monthly'];
          }
          if (type === 'data') {
            return [donor.monthly_donations];
          }

          return [
            {
              'render': (data, type) => {
                if (type === 'display') {
                  return this.prepareParamValue('monthly', {monthly_donations: data});
                }
                return data;
              },
              'width': '90px',
              'orderSequence': ['desc', 'asc'],
              'targets': startIndex,
            },
          ];
        case 'totals':
          if (type === 'header') {
            return ['Total'];
          }
          if (type === 'data') {
            return [donor.total];
          }

          return [
            {
              'render': (data, type) => {
                if (type === 'display') {
                  return this.prepareParamValue('totals', {total: data});
                }
                return data;
              },
              'width': '115px',
              'orderSequence': ['desc', 'asc'],
              'targets': startIndex,
            },
          ];
        case 'rup-status':
          if (type === 'header') {
            return ['Round-Up Status'];
          }
          if (type === 'data') {
            return [donor.status];
          }

          return [
            {
              'render': (data, type) => {
                if (type === 'display') {
                  return this.prepareParamValue('rup-status', {status: data});
                }
                return data;
              },
              'width': '145px',
              'targets': startIndex,
            },
          ];
        case 'phone':
          if (type === 'header') {
            return ['Phone Number'];
          }
          if (type === 'data') {
            return [donor.phone_number];
          }

          return [
            {
              'render': (data, type) => {
                if (type === 'display') {
                  return this.prepareParamValue('phone', {phone_number: data});
                }
                return data;
              },
              'width': '160px',
              'orderSequence': ['desc', 'asc'],
              'targets': startIndex,
              // 'visible': selectedColumns.indexOf('phone') !== -1,
            },
          ];
        case 'notifications':
          if (type === 'header') {
            return ['Texts'];
          }
          if (type === 'data') {
            return [donor.sms_enabled];
          }

          return [
            {
              'render': (data, type) => {
                if (type === 'display') {
                  return this.prepareParamValue('notifications', {sms_enabled: data});
                }
                return data;
              },
              'width': '102px',
              'orderSequence': ['desc', 'asc'],
              'targets': startIndex,
              // 'visible': selectedColumns.indexOf('notifications') !== -1,
            },
          ];
        case 'address':
          if (type === 'header') {
            return ['Address'];
          }

          if (type === 'data') {
            if (donor.address) {
              return escapeHtml(
                (donor.address.street_number ? donor.address.street_number + ' ' : '') +
                (donor.address.route ? donor.address.route + ' ' : '') +
                (donor.address.premise ? `\n${donor.address.premise}` + ' ' : '')
              );
            }
            return ['--'];
          }
          return [
            {
              'render': (data, type) => {
                if (data === '--' && type === 'sort') {
                  return 'zzz';
                }
                if (type === 'display') {
                  return `<div style="white-space: pre-wrap">`+data+`</div><div class="info">${ucwords(column)}</div>`;
                }
                return data;
              },
              'width': '240px',
              'orderSequence': ['asc', 'desc'],
              'targets': startIndex,
            },
          ];
        case 'city':
          if (type === 'header') {
            return ['City'];
          }

          if (type === 'data') {
            if (donor.address && donor.address.locality) {
              return escapeHtml(donor.address.locality);
            }
            return ['--'];
          }
          return [
            {
              'render': (data, type) => {
                if (data === '--' && type === 'sort') {
                  return 'zzz';
                }
                if (type === 'display') {
                  return `<span>${data}</span><div class="info">${ucwords(column)}</div>`;
                }
                return data;
              },
              'width': '100px',
              'orderSequence': ['asc', 'desc'],
              'targets': startIndex,
            },
          ];
        case 'state':
          if (type === 'header') {
            return ['State'];
          }

          if (type === 'data') {
            if (donor.address && donor.address.administrative_area_level_1) {
              return escapeHtml(donor.address.administrative_area_level_1);
            }
            return ['--'];
          }
          return [
            {
              'render': (data, type) => {
                if (data === '--' && type === 'sort') {
                  return 'zzz';
                }
                if (type === 'display') {
                  return `<span>${data}</span><div class="info">${ucwords(column)}</div>`;
                }
                return data;
              },
              'width': '100px',
              'orderSequence': ['asc', 'desc'],
              'targets': startIndex,
            },
          ];
        case 'zip-code':
          if (type === 'header') {
            return ['Zip Code'];
          }

          if (type === 'data') {
            if (donor.address && donor.address.postal_code) {
              return escapeHtml(donor.address.postal_code);
            }
            return ['--'];
          }
          return [
            {
              'render': (data, type) => {
                if (type === 'sort') {
                  return data === '--' ? 999999999 : parseInt(data);
                }
                if (type === 'display') {
                  return `<span>${data}</span><div class="info">${ucwords(column)}</div>`;
                }
                return data;
              },
              'width': '100px',
              'orderSequence': ['asc', 'desc'],
              'targets': startIndex,
            },
          ];
        case 'employer':
        case 'position':
          if (type === 'header') {
            return [ucwords(column)];
          }

          if (type === 'data') {
            if (column === 'employer' && donor.employment && donor.employment.employer) {
              return escapeHtml(donor.employment.employer);
            } else if (column === 'position' && donor.employment && donor.employment.occupation) {
              return escapeHtml(donor.employment.occupation);
            }
            return ['--'];
          }
          return [
            {
              'render': (data, type) => {
                if (data === '--' && type === 'sort') {
                  return 'zzz';
                }
                if (type === 'display') {
                  return `<span>${data}</span><div class="info">${ucwords(column)}</div>`;
                }
                return data;
              },
              'width': column === 'position'?'220px':'110px',
              'orderSequence': ['asc', 'desc'],
              'targets': startIndex,
            },
          ];
        default:
          if (type === 'header') {
            return [ucwords(column)];
          }
          if (type === 'data') {

            if (donor.metadata && donor.metadata.length) {
              let valCol = donor.metadata.filter(v => v.column.name === column);
              if (valCol && valCol.length) {
                return escapeHtml(valCol[0].value);
              }
            }

            return ['--'];
          }
          return [
            {
              'render': (data, type) => {
                if (type === 'sort') {
                  if (column === 'age') {
                    return data === '--' ? 999999999 : parseInt(data);
                  }
                  if (data === '--') {
                    return 'zzz';
                  }
                }
                if (type === 'display') {
                  return `<span>${data}</span><div class="info">${ucwords(column)}</div>`;
                }
                return data;
              },
              'width': '100px',
              'orderSequence': ['asc', 'desc'],
              'targets': startIndex,
            },
          ];
      }
    },
  },
};
